import { render } from "./ProjectDeadline.vue?vue&type=template&id=a9f9555e"
import script from "./ProjectDeadline.vue?vue&type=script&lang=js"
export * from "./ProjectDeadline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__